import { PANAFRICAN } from "@/constants/testIds";
import { BeninFlag, SimpleFlag } from "@/components/landing/BeninFlag";

const COUNTRIES = [
  { name: "Bénin", status: "active" },
  { name: "Togo", status: "soon", colors: ["#006A4E", "#FFCE00", "#D21034"] },
  { name: "Sénégal", status: "soon", colors: ["#00853F", "#FDEF42", "#E31B23"] },
  { name: "Côte d'Ivoire", status: "soon", colors: ["#F77F00", "#FFFFFF", "#009E60"] },
  { name: "Burkina Faso", status: "soon", colors: ["#EF2B2D", "#FCD116", "#009E49"] },
  { name: "Niger", status: "soon", colors: ["#E05206", "#FFFFFF", "#0DB02B"] },
];

export const PanAfrican = () => {
  return (
    <section
      id="panafrican"
      data-testid={PANAFRICAN.root}
      className="relative py-20 md:py-24 bg-[#FBFAF6] overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
              La déclinaison panafricaine
            </p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl text-[#16241B] leading-[1.05] tracking-tighter">
              Un nom,
              <br />
              <span className="text-[#F5A800]">un continent.</span>
            </h2>
            <p className="mt-5 text-[#16241B]/70 text-base leading-relaxed max-w-md">
              Zafara Bénin, aujourd'hui. Zafara partout où on grandira demain.
              Le nom se décline naturellement, sans jamais perdre son identité.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-3xl bg-white border border-[#EDE7D9] p-8 md:p-10 overflow-hidden">
              <svg viewBox="0 0 400 280" className="w-full h-auto max-h-[320px]" aria-hidden="true">
                <path
                  d="M 60 80 Q 40 100 50 140 Q 55 180 90 200 Q 130 220 180 220 Q 240 225 290 210 Q 340 195 355 160 Q 365 120 340 90 Q 300 60 240 55 Q 180 50 130 55 Q 85 60 60 80 Z"
                  fill="#E7F3EC"
                  stroke="#0E7A3B"
                  strokeWidth="1.5"
                />
                <g>
                  <circle cx="215" cy="155" r="18" fill="#F5A800" opacity="0.35">
                    <animate attributeName="r" values="18;28;18" dur="2.5s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.35;0;0.35" dur="2.5s" repeatCount="indefinite" />
                  </circle>
                  <circle cx="215" cy="155" r="9" fill="#0E7A3B" />
                  <circle cx="215" cy="155" r="4" fill="#F5A800" />
                </g>
                {[
                  { x: 190, y: 145 },
                  { x: 130, y: 130 },
                  { x: 80, y: 115 },
                  { x: 175, y: 105 },
                  { x: 240, y: 105 },
                ].map((p, i) => (
                  <circle key={i} cx={p.x} cy={p.y} r="5" fill="#16241B" opacity="0.25" />
                ))}
              </svg>
              <p className="mt-2 text-center font-utility text-[10px] uppercase tracking-widest text-[#16241B]/50">
                Afrique de l'Ouest · Illustration stylisée
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          {COUNTRIES.map((c) => (
            <div
              key={c.name}
              className={`inline-flex items-center gap-2.5 rounded-full border pl-2 pr-4 py-2 transition-all ${
                c.status === "active"
                  ? "border-[#0E7A3B] bg-[#0E7A3B] text-white shadow-[0_8px_24px_rgba(14,122,59,0.25)]"
                  : "border-[#EDE7D9] bg-white text-[#16241B]/60"
              }`}
            >
              {c.name === "Bénin" ? (
                <BeninFlag className="h-4 w-6" />
              ) : (
                <SimpleFlag colors={c.colors} className="h-4 w-6" />
              )}
              <span className="font-display font-semibold text-sm">
                Zafara {c.name}
              </span>
              {c.status === "active" ? (
                <span className="font-utility text-[9px] uppercase tracking-widest px-2 py-0.5 rounded-full bg-[#F5A800] text-[#16241B]">
                  Actif
                </span>
              ) : (
                <span className="font-utility text-[9px] uppercase tracking-widest text-[#16241B]/40">
                  Bientôt
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
